import React from 'react'
import List from '../components/List'
import hipladeTemplate from '../../common/template'

function ListScenarios() {
  return <List />
}

export default hipladeTemplate(ListScenarios)
